import { Container, Flex, Text, Heading, Grid, Box } from '@radix-ui/themes';
import Card from '@trashlab/sitesapp/src/organizations/denversiteworks/template/components/shared/card';
import FormFields from '@trashlab/sitesapp/src/organizations/denversiteworks/template/components/shared/form-fields';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/denversiteworks/lib/utils/get-variant-value';

export const BestDealAbout = () => {
  const getStartedTitle = useVariantValue(
    'BEST_DEAL_GET_STARTED_TITLE',
    'Get Started with Best Deal Dumpsters',
  );

  const getStartedDescription = useVariantValue(
    'BEST_DEAL_GET_STARTED_DESCRIPTION',
    'Best Deal not only has the best prices, but we are unparalleled in service and quality. You can count on us for on-time and on-budget deliveries. We are a small, locally owned company and our customers and community are important to us. Because Best Deal specializes in driveway deliveries, we use smaller trucks to protect your driveway from cracks and damage.',
  );

  const contactAddress = useVariantValue(
    'BEST_DEAL_ADDRESS',
    '4621 Knopp Ave Louisville, KY 40213',
  );

  const contactPhone = useVariantValue('BEST_DEAL_PHONE', '502-396-0666');

  const contactEmail = useVariantValue(
    'BEST_DEAL_EMAIL',
    'contact@bestdealdumpsters.com',
  );

  return (
    <Container size="4" p="8">
      <Grid columns={{ initial: '1', md: '2' }} gap="8">
        {/* Left side: Get Started + Contact Info */}
        <Flex direction="column" gap="6">
          {/* Get Started Section */}
          <Card padding="6">
            <Flex direction="column" gap="4">
              <Heading
                as="h2"
                size="7"
                weight="bold"
                data-variable="BEST_DEAL_GET_STARTED_TITLE"
              >
                {getStartedTitle}
              </Heading>
              <Text
                size="3"
                className="text-neutral-600 leading-relaxed"
                data-variable="BEST_DEAL_GET_STARTED_DESCRIPTION"
              >
                {getStartedDescription}
              </Text>
            </Flex>
          </Card>

          {/* Contact Information */}
          <Card padding="6">
            <Flex direction="column" gap="4">
              <Heading as="h3" size="5" weight="bold">
                Contact Information
              </Heading>

              <Flex direction="column" gap="3">
                <Flex direction="column" gap="1">
                  <Text size="2" weight="medium" className="text-neutral-500">
                    Address
                  </Text>
                  <Text
                    size="3"
                    className="text-neutral-800"
                    data-variable="BEST_DEAL_ADDRESS"
                  >
                    {contactAddress}
                  </Text>
                </Flex>

                <Flex direction="column" gap="1">
                  <Text size="2" weight="medium" className="text-neutral-500">
                    Phone
                  </Text>
                  <a
                    href={`tel:${contactPhone}`}
                    className="text-[var(--primary-color)] hover:underline"
                  >
                    <Text size="3" data-variable="BEST_DEAL_PHONE">
                      {contactPhone}
                    </Text>
                  </a>
                </Flex>

                <Flex direction="column" gap="1">
                  <Text size="2" weight="medium" className="text-neutral-500">
                    Email
                  </Text>
                  <a
                    href={`mailto:${contactEmail}`}
                    className="text-[var(--primary-color)] hover:underline"
                  >
                    <Text size="3" data-variable="BEST_DEAL_EMAIL">
                      {contactEmail}
                    </Text>
                  </a>
                </Flex>
              </Flex>
            </Flex>
          </Card>
        </Flex>

        {/* Right side: Contact Form */}
        <Card padding="6">
          <Flex direction="column" gap="4">
            <Box>
              <Text weight="bold" size="2" className="text-neutral-400">
                Ready to rent?
              </Text>
              <Heading as="h3" size="7" weight="bold" className="mt-1">
                Contact Us
              </Heading>
              <Text size="2" className="text-neutral-500 mt-2">
                Fill out the form below and we&apos;ll get back to you as soon
                as possible.
              </Text>
            </Box>
            <Box className="mt-2">
              <FormFields />
            </Box>
          </Flex>
        </Card>
      </Grid>
    </Container>
  );
};

export default BestDealAbout;
